<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    width="920px"
    top="7vh"
    append-to-body
    :close-on-click-modal="false"
    :lock-scroll="true"
    custom-class="linkAssociationDialog"
    @close="handleDialogClose"
    @closed="handleClosed"
  >
    <!--
      弹层挂载到 body，避免 resourceFormPage 内 overflow:hidden 导致无法滚动/点击。
      内容区固定高度，内部 picker 自行分配滚动。
    -->
    <div class="linkAssociationDialog__body">
      <slot />
    </div>
    <span slot="footer" class="linkAssociationDialog__footer">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 创建/编辑页 · 关联分类/Tag 选择弹层。
 * 统一 append-to-body + 固定高度内容区，供 tagPicker / categoryPicker 嵌入。
 */
export default {
  name: 'AssociationPickerDialog',
  props: {
    title: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmed: false,
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(next) {
        this.$emit('update:visible', next);
      },
    },
  },
  methods: {
    cancel() {
      this.confirmed = false;
      this.$emit('cancel');
      this.innerVisible = false;
    },
    confirm() {
      this.confirmed = true;
      this.$emit('confirm');
      this.innerVisible = false;
    },
    handleDialogClose() {
      if (!this.confirmed) {
        this.$emit('cancel');
      }
    },
    handleClosed() {
      this.confirmed = false;
      this.$emit('closed');
    },
  },
};
</script>

<style src="./associationPickerDialog.css"></style>
